module.exports = __webpack_public_path__ + "img/117.6152dd47.png";